import type { Contact } from '@capacitor/contacts';

export interface DeviceContact { name: string; phone: string; email: string }
export interface WebContact { name?: string[]; tel?: string[]; email?: string[] }

export function phoneValue(value: string): string {
  const compact = value.trim().replace(/[\s().-]/g, '');
  return compact.replace(/^(?:\+972|00972)/, '0');
}

export function nativeContactValues(contact: Contact): DeviceContact {
  return {
    name: (contact.displayName || contact.name?.formatted || [contact.name?.givenName, contact.name?.familyName].filter(Boolean).join(' ')).trim(),
    phone: phoneValue(contact.phoneNumbers?.find((item) => item.value?.trim())?.value ?? ''),
    email: (contact.emails?.find((item) => item.value?.trim())?.value ?? '').trim(),
  };
}
export function webContactValues(contact: WebContact): DeviceContact {
  return { name: contact.name?.[0]?.trim() ?? '', phone: phoneValue(contact.tel?.[0] ?? ''), email: contact.email?.[0]?.trim() ?? '' };
}

export function contactFailure(error: unknown): 'cancelled' | 'denied' | 'unavailable' {
  const value = error as { code?: string; name?: string } | null;
  if (value?.code === 'OS-PLUG-CONT-0006' || value?.name === 'AbortError') return 'cancelled';
  if (value?.code === 'OS-PLUG-CONT-0020' || value?.name === 'NotAllowedError') return 'denied';
  return 'unavailable';
}
